module.exports = __webpack_public_path__ + "static/scale-model-of-tucson-audubon-society-in-tucson-arizona-329a2000007ec125cdbb5346c6b98b1b.png";